import type { ID } from '@octopus-do/octopus-project-core'

import { createSwitch } from '@/utils'

export const useUserItemMenu = (
  id: ID,
  changesShown: boolean,
  onSetChangesIsOpen: (id: string | null) => void,
  onRestore: () => void
) => {
  const switcher = createSwitch()
    .case(['changes'], () => onSetChangesIsOpen(changesShown ? null : id))
    .case(['restore'], onRestore)

  const onClick = (keys: string[]) => switcher.run(keys)

  return {
    onClick,
  }
}
